import { createAction } from "@reduxjs/toolkit";
import { RootState } from ".";

// Special action types
export const loadAction = createAction<RootState["document"]>("loadDocument");
